import React, { useState, useEffect } from 'react';
import IconCandyMenu from '../svg/IconCandyMenu';
import IconUserInitials from '../svg/IconUserInitials';
import IconLogoAdserve from '../svg/IconLogoAdserve';
import { cognitoSignOut, getClaimValue } from '../adios';
import AsLoading from '../AsLoading';
import AboutThisModule from './AboutThisModule';

const titleBarStyle = {
    boxSizing: 'border-box',
    boxShadow: '3px 2px 11px 0 rgba(0,0,0,0.33)',
    backgroundColor: '#FFFFFF',
    display: 'flex',
    alignItems: 'center',
    height: 50,
    marginTop: 2,
    zIndex: 1001
};

const modulePanelContainerStyle = {
    width: 298,
    position: 'absolute',
    left: '1%',
    top: 52,
    zIndex: 1000
};

const modulePanelStyle = {
    boxSizing: 'border-box',
    width: '100%',
    border: '1px solid #CCCCCC',
    borderRadius: '0 0 15px 15px',
    backgroundColor: '#FFFFFF',
    boxShadow: '0px 10px 10px 2px rgba(0,0,0,0.33)'
};

const accountPanelContainerStyle = {
    width: 241,
    position: 'absolute',
    right: '1%',
    top: 52,
    zIndex: 1000
};

const accountPanelStyle = {
    boxSizing: 'border-box',
    width: '100%',
    border: '1px solid #CCCCCC',
    borderRadius: '0 0 15px 15px',
    backgroundColor: '#FFFFFF',
    boxShadow: '0px 10px 10px 2px rgba(0,0,0,0.33)'
};

const bannerStyle = {
    boxSizing: 'border-box',
    height: 5,
    width: '100%',
    border: '1px solid #D7D7D7',
    backgroundColor: '#D7D7D7'
};

const listItemStyle = {
    boxSizing: 'border-box',
    display: 'flex',
    alignItems: 'center',
    height: 37,
    width: '100%',
    borderBottom: '1px solid #D7D7D7',
    color: '#414141',
    fontFamily: 'Roboto',
    fontSize: 14,
    fontWeight: 500,
    paddingLeft: '12%',
    cursor: 'pointer'
};

const moduleTitleStyle = {
    color: '#414141',
    fontFamily: 'Roboto',
    fontSize: 24,
    fontWeight: 500
};

const moduleTitleContainerStyle = {
    display: 'flex',
    width: '46.3%',
    flexDirection: 'column',
    alignItems: 'center'
};

const userAccountContainerStyle = {
    display: 'flex',
    width: '27.7%',
    flexDirection: 'row',
    alignItems: 'flex-start',
    justifyContent: 'end',
    marginRight: 31
};

const dropdownListStyle = {
    listStyle: 'none',
    padding: 0,
    WebkitPaddingStart: 0,
    marginTop: 0,
    marginBottom: 0
};

const AsTitlebar = ({
    productName = 'Adserve Studio',
    moduleTitle = '',
    title,
    animationDuration,
    logo,
    moduleLinks,
    useHelpWidget = true,
    loadingModules = false,
    moduleError = ''
}) => {
    const [modulesShowing, setModulesShowing] = useState(false);
    const [userOptionsShowing, setUserOptionsShowing] = useState(false);
    const [menuModules, setMenuModules] = useState([]);
    const [userModules, setUserModules] = useState([]);
    const [approvalModule, setApprovalModule] = useState(null);
    const [aboutVisible, setAboutVisible] = useState(false);

    useEffect(() => {
        if (moduleLinks?.length > 0) {
            const modules = moduleLinks?.filter((m) => m.inUserMenu === false);
            setMenuModules(modules);

            const usermodules = moduleLinks?.filter((m) => m.inUserMenu === true);
            setUserModules(usermodules);

            const am = moduleLinks?.filter((m) => m.shortCode === 'ARR' || m.shortCode === 'ARS');
            if (am?.length > 0) {
                setApprovalModule(am[0]);
            }
        }
    }, [moduleLinks]);

    const handleHoverEnter = (event) => {
        event.currentTarget.style.backgroundColor = '#DCFFFF';
    };

    const handleHoverLeave = (event, i) => {
        event.currentTarget.style.backgroundColor = i % 2 === 0 ? '#F7F7F7' : '#FFFFFF';
    };

    const handleModuleClick = (url) => {
        url ? window.open(url, '_self') : alert('TODO: Provide module URL when ready');
    };

    const handleHelpClick = () => {
        setUserOptionsShowing(false);

        if (useHelpWidget) {
            window.FreshworksWidget('identify', 'ticketForm', {
                name: getClaimValue('fullName'),
                email: getClaimValue('email')
            });

            window.FreshworksWidget('prefill', 'ticketForm', {
                custom_fields: {
                    cf_product: productName,
                    cf_function: moduleTitle
                }
            });

            window.FreshworksWidget('hide', 'ticketForm', ['custom_fields.cf_product']);

            window.FreshworksWidget('disable', 'ticketForm', ['custom_fields.cf_function']);

            window.FreshworksWidget('hideChoices', 'ticketForm', {
                type: ['Software Bug', 'Hardware/Network Issue', 'Report an Incident']
            });

            window.FreshworksWidget('open');
        }
    };

    const handleAboutClick = () => {
        setAboutVisible(true);
    };

    const handleAboutClose = () => {
        setAboutVisible(false);
    };

    // const handleChangePasswordClick = () => {
    //     setUserOptionsShowing(false);
    //     // eslint-disable-next-line no-alert
    //     alert('TODO: Re-direct to first screen for a Change Password journey');
    // };

    const moduleContent = () => {
        if (loadingModules) {
            if (moduleError === '') {
                return (
                    <div style={{ width: '100%', height: 100 }}>
                        <AsLoading />
                    </div>
                );
            } else {
                return (
                    <div style={{ fontSize: 15, margin: 10 }}>
                        <span>{moduleError}</span>
                    </div>
                );
            }
        } else {
            return (
                <ul style={dropdownListStyle}>
                    {menuModules.map((module, i) => (
                        <li
                            key={`module${i}`}
                            id={module?.name.toLowerCase().replace(/ /g, '-')}
                            style={{
                                ...listItemStyle,
                                backgroundColor: i % 2 === 0 ? '#F7F7F7' : '#FFFFFF',
                                color: module?.name === moduleTitle ? '#FD9A00' : '#414141'
                            }}
                            onMouseEnter={handleHoverEnter}
                            onMouseLeave={(e) => handleHoverLeave(e, i)}
                            onClick={() =>
                                module?.name === moduleTitle ? null : handleModuleClick(module?.url)
                            }
                        >
                            {module?.name}
                        </li>
                    ))}
                </ul>
            );
        }
    };

    const handleGoToRecycleBin = () => {
        setUserOptionsShowing(false);
        const recycleModule = userModules?.filter((m) => m.shortCode === 'RECYCLE');
        if (recycleModule?.length > 0) window.open(recycleModule[0].url, '_self');
    };

    const handleGoToApprovalRequests = () => {
        setUserOptionsShowing(false);
        window.open(approvalModule.url, '_self');
    };

    return (
        <div style={titleBarStyle}>
            <AboutThisModule onClose={handleAboutClose} visible={aboutVisible} />
            <div
                style={{
                    display: 'flex',
                    width: '26%'
                }}
            >
                <div style={{ marginLeft: '10%', paddingTop: 8 }}>
                    <IconCandyMenu
                        animationDuration={animationDuration}
                        isHighlighted={modulesShowing}
                        handleClick={() => setModulesShowing(!modulesShowing)}
                    />
                </div>
                <div style={{ marginLeft: 30, paddingTop: 5 }}>
                    {logo?.length ? (
                        <img src={logo} width='auto' height={40} />
                    ) : (
                        <IconLogoAdserve width={40} height={40} />
                    )}
                </div>
            </div>

            <div style={moduleTitleContainerStyle}>
                <span style={moduleTitleStyle}>{title || ''}</span>
            </div>

            <div style={userAccountContainerStyle}>
                <IconUserInitials
                    isHighlighted={userOptionsShowing}
                    approvalModule={approvalModule}
                    handleClick={() => setUserOptionsShowing(!userOptionsShowing)}
                />
                {approvalModule?.approvalRequests > 0 && (
                    <div style={{ fontFamily: 'roboto', fontSize: 14, fontWeight: 'bold' }}>
                        {approvalModule.approvalRequests}
                    </div>
                )}
            </div>

            {modulesShowing && (
                <div style={modulePanelContainerStyle}>
                    <div style={modulePanelStyle}>
                        <div style={bannerStyle} />
                        {moduleContent()}
                        <div style={{ height: 12 }} />
                    </div>
                </div>
            )}

            {userOptionsShowing && (
                <div style={accountPanelContainerStyle}>
                    <div style={accountPanelStyle}>
                        <div style={bannerStyle} />
                        <ul style={dropdownListStyle}>
                            {approvalModule && (
                                <li
                                    id='approval-requests'
                                    style={{
                                        ...listItemStyle,
                                        backgroundColor: '#F7F7F7',
                                        paddingLeft: '14.5%'
                                    }}
                                    onMouseEnter={handleHoverEnter}
                                    onMouseLeave={(e) => handleHoverLeave(e, 0)}
                                    onClick={handleGoToApprovalRequests}
                                >
                                    Workflow & Approvals
                                    {approvalModule.approvalRequests > 0
                                        ? `  (${approvalModule.approvalRequests})`
                                        : ''}
                                </li>
                            )}

                            <li
                                id='help-&-tutorials'
                                style={{
                                    ...listItemStyle,
                                    backgroundColor: '#F7F7F7',
                                    paddingLeft: '14.5%'
                                }}
                                onMouseEnter={handleHoverEnter}
                                onMouseLeave={(e) => handleHoverLeave(e, 1)}
                                onClick={() => handleHelpClick(true)}
                            >
                                Help & Tutorials
                            </li>

                            {/* <li
                                id='change-password'
                                style={{
                                    ...listItemStyle,
                                    backgroundColor: '#FFFFFF',
                                    paddingLeft: '14.5%'
                                }}
                                onMouseEnter={handleHoverEnter}
                                onMouseLeave={(e) => handleHoverLeave(e, 1)}
                                onClick={handleChangePasswordClick}
                            >
                                Change Password
                            </li> */}

                            {userModules?.filter((m) => m.shortCode === 'RECYCLE')?.length > 0 && (
                                <li
                                    id='recycle-bin'
                                    style={{
                                        ...listItemStyle,
                                        backgroundColor: '#F7F7F7',
                                        paddingLeft: '14.5%'
                                    }}
                                    onMouseEnter={handleHoverEnter}
                                    onMouseLeave={(e) => handleHoverLeave(e, 2)}
                                    onClick={handleGoToRecycleBin}
                                >
                                    Recycle Bin
                                </li>
                            )}

                            <li
                                id='help-&-tutorials'
                                style={{
                                    ...listItemStyle,
                                    backgroundColor: '#F7F7F7',
                                    paddingLeft: '14.5%'
                                }}
                                onMouseEnter={handleHoverEnter}
                                onMouseLeave={(e) => handleHoverLeave(e, 3)}
                                onClick={handleAboutClick}
                            >
                                About this Module
                            </li>

                            <li
                                id='sign-out'
                                style={{
                                    ...listItemStyle,
                                    backgroundColor: '#F7F7F7',
                                    paddingLeft: '14.5%'
                                }}
                                onMouseEnter={handleHoverEnter}
                                onMouseLeave={(e) => handleHoverLeave(e, 4)}
                                onClick={cognitoSignOut}
                            >
                                Sign Out
                            </li>
                        </ul>
                        <div style={{ height: 12 }} />
                    </div>
                </div>
            )}
        </div>
    );
};

export default AsTitlebar;
